import { ComponentClass } from 'react';
import { LazyAction, LazyImport, LazyModule, createLazyComponent } from 'owa-bundling';

const getStartedLazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "GetStarted" */ './lazyIndex')
);

export { ComponentClass };
export { GetStartedListPosition } from './enums/GetStartedListPosition';

export let GetStartedListInQuickOption = createLazyComponent(
    getStartedLazyModule,
    m => m.GetStartedListInQuickOption
);

export let GetStartedListInFlexPane = createLazyComponent(
    getStartedLazyModule,
    m => m.GetStartedListInFlexPane
);

export let GetStartedListInListView = createLazyComponent(
    getStartedLazyModule,
    m => m.GetStartedListInListView
);

export let initializeGetStartedTasksLazy = new LazyImport(
    getStartedLazyModule,
    m => m.getInitializeGetStartedPromise
);

export let enableGetStartedExperienceLazy = new LazyAction(
    getStartedLazyModule,
    m => m.enableGetStartedExperience
);
